export default {
  getFeed: (state) => state.feed,
  getFeedTotal: (state) => state.total,
  getFeedPage: (state) => state.page,
  getFeedVisible: (state) => state.visible
}
